/* @flow */

import { Map, List } from 'immutable';

import {
  PROMOTIONS_LIST_REQUEST,
  PROMOTIONS_LIST_SUCCESS,
  PROMOTIONS_LIST_FAILURE,
} from './action';

const initialState = Map({
  type: '', loading: false, payload: List([]), messages: List([]),
});

export default function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === PROMOTIONS_LIST_REQUEST) {
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => true);
  }

  if (type === PROMOTIONS_LIST_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['loading'], () => false)
      .updateIn(['messages'], () => List([]))
      .setIn(['payload'], List(payload));
  }

  if (type === PROMOTIONS_LIST_FAILURE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => false).setIn(['messages'], List(payload));
  }

  return state;
}
